import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import "./Zone.css";

const url = process.env.REACT_APP_BACKEND_URL;

const EditZone = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [name, setName] = useState("");

  useEffect(() => {
    const fetchZone = async () => {
      try {
        const response = await axios.get(`${url}/api/zone/${id}`);
        setName(response.data.data.name);
      } catch (error) {
        toast.error("Failed to load zone data");
        navigate("/ViewZone");
      } finally {
        setLoading(false);
      }
    };
    fetchZone();
  }, [id, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      toast.error("Zone name is required");
      return;
    }

    setSubmitting(true);

    try {
      const response = await axios.put(`${url}/api/zone/${id}`, { name: name.trim() });
      if (response.data.success) {
        toast.success("Zone updated successfully!");
        navigate("/ViewZone");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update zone");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div className="loading">Loading zone...</div>;

  return (
    <div className="district-container">
      <div className="header">
        <h2>Edit Zone</h2>
        <button onClick={() => navigate("/ViewZone")} className="add-button">
          Back to List
        </button>
      </div>

      <form className="district-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Zone Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter zone name"
            required
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="submit-button" disabled={submitting}>
            {submitting ? "Updating..." : "Update Zone"}
          </button>
          <button
            type="button"
            onClick={() => navigate("/ViewZone")}
            className="cancel-button"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditZone;